
import { defineComponent } from 'vue'
import NotificationDialog from './components/NotificationDialog.vue';

export default defineComponent({
  name: 'App',
  components: {NotificationDialog},
  setup() {

  }
})
